<script>
    export let isEdit;
    export let isRenew;
    export let id;
</script>

<div class="flex flex-wrap items-center justify-between w-full">
    <h3 class="font-semibold text-3xl">
        {#if isRenew}
            Rinnovo iscrizione
        {:else}
            {isEdit ? "Modifica" : "Crea"} iscritto
        {/if}
    </h3>
</div>